module.exports = __webpack_public_path__ + "media/images/logo-0ca7c7d6b48e6c3d3214ee97ca0f6c86.png";